export default {
  WarehouseReceivingOrder: 'WarehouseReceivingOrder',
  CreateWarehouseReceivingOrder: 'CreateWarehouseReceivingOrder',
  ChooseWarehouseReceivingOrderType: 'ChooseWarehouseReceivingOrderType',
  CreateWroConfirmation: 'CreateWroConfirmation',
  CreateWarehouseReceivingOrderPlaceholder: 'CreateWarehouseReceivingOrderPlaceholder',
  WarehouseReceivingOrderPlaceholder: 'WarehouseReceivingOrderPlaceholder',
  UpdateDraftWroPlaceholder: 'UpdateDraftWroPlaceholder',
  DownloadBoxLabels: 'DownloadBoxLabels',
  CancelWro: 'CancelWro',
  UpdateWro: 'UpdateWro',
  EditWroConfirmation: 'EditWroConfirmation',
  EditWro: 'EditWro'
}
